import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import noop from 'lib/function/noop'
import AssistChip from 'LuxKit/Chips/AssistChip'
import formatStaticAppText from 'lib/format/formatStaticAppText'

export interface Option {
  value: string
  text: string
  url: string
}

interface Props {
  onClickHandler?: (option: Option) => void
  onContextMenuHandler?: (option: Option) => void
  onImpressionHandler?: (option: Option) => void
  option: Option
}

function PopularDestinationButton({
  onClickHandler = noop,
  onContextMenuHandler = noop,
  onImpressionHandler,
  option,
}: Props) {
  const intl = useIntl()

  useEffect(() => {
    onImpressionHandler?.(option)
  }, [onImpressionHandler, option])

  return <AssistChip
    size="medium"
    variant="filled"
    key={option.value}
    rel="nofollow"
    to={option.url}
    onClick={() => onClickHandler(option)}
    onContextMenu={() => onContextMenuHandler(option)}
  >
    {formatStaticAppText(intl, option.text)}
  </AssistChip>
}

export default PopularDestinationButton
